import { LinksCardBlock } from "../../LinksCard/types";
import { LinksBlock } from "../types";
import { copy as copyLinksCardBlock } from "../../LinksCard/Block/copy";

export function copy(block: LinksBlock): LinksBlock {
  return {
    ...block,
    config: {
      ...block.config,
      id: undefined,
    },
    children: block.children.map<LinksCardBlock>((child) =>
      copyLinksCardBlock(child)
    ),
  };
}
